import {getDeviceAreaInfo} from "@/api/device-api";

export const areaCheckMixin = {
    data() {
        return {
            areaId: 0,
            areaInfo: {},
            notify: {title: "签到结果", show: false, success: false, msg: "签到成功",},
        }
    },

    methods: {
        setupAreaInfo() {
            this.areaId = this.$store.state.areaId
            console.log("getDeviceAreaInfo param " + this.areaId)
            // 区域可选：未配置（空/"0"/0）不发请求；data.data 为空不得写入 store
            // （否则 areaInfo 变 null，签到/签离的 checkDeviceArea 会 TypeError 静默失败）
            if (!(Number(this.areaId) > 0)) {
                return
            }
            getDeviceAreaInfo(this.areaId).then(({data}) => {
                console.log("getDeviceAreaInfo result " + JSON.stringify(data))

                if (data.code === 200 && data.data && data.data.id) {
                    this.$store.commit('setAreaInfo', data.data)
                    this.areaInfo = data.data
                } else {
                    this.areaInfo = this.$store.state.areaInfo
                }
            }).catch(() => {
                this.areaInfo = this.$store.state.areaInfo
            })
        },


        async getAreaNameById(areaId) {
            let areaName = ""
            let rsp = await getDeviceAreaInfo(areaId)
            console.log("getAreaNameById :: result ", rsp)
            console.log("getAreaNameById :: areaId ", areaId)
            if (rsp.data && rsp.data.code === 200 && rsp.data.data) {
                areaName = rsp.data.data.address
            }
            return areaName
        },

        async checkDeviceArea(applyInfo, isEnter) {
            // areaInfo 为空/缺省一律视为无需区域验证（未配区域设备的正常形态）
            let areaInfo = this.$store.state.areaInfo || {}
            let areaId = this.$store.state.areaId
            if (areaInfo.verify !== 1) {
                console.log("checkDeviceArea: no need ", areaInfo)
                // 不需要区域验证，直接返回
                return true
            }
            if (applyInfo.entryArea.toString() === areaId.toString()) {
                console.log("checkDeviceArea: ok ", areaInfo)
                return true
            }
            const localAreaName = areaInfo.address
            const applyAreaName = await this.getAreaNameById(applyInfo.entryArea)
            console.log("checkDeviceArea: ", localAreaName, applyAreaName)
            let errmsg
            if (isEnter) {
                errmsg = `签到地址错误<br/>当前地址为：${localAreaName}<br/>请到 ${applyAreaName} 签到`
            } else {
                errmsg = `签离地址错误<br/>当前地址为：${localAreaName}<br/>请到 ${applyAreaName} 签离`
            }
            let title = isEnter ? "签到结果" : "签离结果"
            this.notify = {
                title: title,
                show: true,
                success: false,
                msg: errmsg,
            }
            return false
        },

    }
}
